import type { LocationId, PropertyType, OrderType } from '../game/types';

/**
 * All valid location IDs
 */
export const LOCATION_IDS: LocationId[] = ['cell_1', 'cell_2', 'cell_3', 'cell_4', 'control_room'];

/**
 * All valid property types
 */
export const PROPERTY_TYPES: PropertyType[] = ['Lethal', 'Memetic', 'Antiepistemic', 'Breaching', 'Hyperreal', 'Dormant'];

/**
 * All valid order types
 */
export const ORDER_TYPES: OrderType[] = ['Move', 'Research', 'Contain', 'Craft', 'Accept', 'Coredump', 'Recruit', 'Synthetize', 'Rest'];

/**
 * Cell location IDs (excluding control room)
 */
export const CELL_LOCATIONS: LocationId[] = ['cell_1', 'cell_2', 'cell_3', 'cell_4'];

